import React, { FunctionComponent } from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  ButtonColor,
  LinkOnClickEvent,
  ICON_EMAIL,
  ICON_PHONE,
} from '@doveit/lego';
import * as styles from './ContactBarMobile.style';

export interface ContactBarMobileProps {
  emailAction: (event: LinkOnClickEvent) => void,
  phone: string,
}

const ContactBarMobile: FunctionComponent<ContactBarMobileProps> = ({
  emailAction,
  phone,
}) => (
  <div>
    <div css={styles.content}>
      <div
        css={styles.text}
        data-ref="buyer-sticky-headline"
      >
        Ti piace questo immobile?
      </div>
      <div css={styles.buttonBox}>
        <Button
          label="Chiama"
          icon={ICON_PHONE}
          size={ButtonSize.SMALL}
          expanded
          href={`tel:${phone}`}
          title={`Chiamaci al numero ${phone} per avere maggiori informazioni`}
        />
      </div>
      <div css={styles.buttonBox}>
        <Button
          label="Invia Email"
          icon={ICON_EMAIL}
          size={ButtonSize.SMALL}
          color={ButtonColor.PRIMARY}
          variant={ButtonVariant.OUTLINE}
          expanded
          onClick={emailAction}
          data-ref="button-email"
        />
      </div>
    </div>
  </div>
);

export default ContactBarMobile;
